'use client';
// ct2: FAQ items OPEN by default, each question with an icon (components/ct2/ct2Icons). Same markup rules as FAQSection:
// answers stay in the DOM when collapsed (SEO + FAQPage JSON-LD parity); each item toggles independently.
import { useState } from 'react';
import type { FAQ } from '@/types';
import { avatarImg } from '@/lib/imgUrl';

export default function Ct2FAQ({ faqs, icons }: { faqs: FAQ[]; icons: string[] }) {
  const [closed, setClosed] = useState<Set<number>>(() => new Set());
  const toggle = (i: number) => setClosed(prev => { const n = new Set(prev); if (n.has(i)) n.delete(i); else n.add(i); return n; });
  return (
    <div className="ct2-faq" dir="rtl">
      {faqs.map((faq, i) => {
        const open = !closed.has(i);
        return (
          <div key={faq.id} className="ct2-faq-item" data-open={open ? '1' : '0'}>
            <button type="button" className="ct2-faq-q" aria-expanded={open} aria-controls={`ct2-faq-a-${i}`} onClick={() => toggle(i)}>
              <img {...avatarImg(icons[i], 48)} alt="" aria-hidden="true" width={48} height={48} loading="lazy" decoding="async" className="ct2-faq-ic" />
              <span className="ct2-faq-qt">{faq.question}</span>
              <span className="ct2-faq-chev" aria-hidden="true">{open ? '−' : '+'}</span>
            </button>
            <div id={`ct2-faq-a-${i}`} className="ct2-faq-a" style={open ? undefined : { display: 'none' }}>
              <p>{faq.answer}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
